itsoftApp.createModule("test", function () {
    const container = document.querySelector('#test');

    if (!container) {
        return;
    }

    let urlGlobal = null;
    let slider = null;

    const prevBtnEls = container.querySelectorAll('.js-test-btn-prev');
    const toggleEls = container.querySelectorAll(".js-test-toggle");
    const formEl = container.querySelector(".js-test-form");
    const startBtn = container.querySelector(".js-start-btn");
    const stepsNum = container.querySelectorAll('.js-test-num');

    let curStepIndex = 1;
    /**
     * Значение должно быть равно transition-delay у .test__slider .swiper-slide.swiper-slide-active в стилях
     */
    let delayChangeStepNum = 400;

    const processResults = function (data) {
        const wrapper = document.createElement("div");
        wrapper.innerHTML = data;
        const resultData = wrapper.querySelector(".js-result");
        const res = document.querySelector('.test__wrapper')
        res.appendChild(resultData)

        container.classList.add('_end-test');


        const link = document.querySelector('.js-anchor-to-test-result');
        link.click();

        const testResetEl = container.querySelector(".js-test-reset");

        if (testResetEl) {
            testResetEl.addEventListener("click", resetTest);
        }

    };

    const resetTest = function (evt) {
        evt.preventDefault();

        const inputs = container.querySelectorAll(".js-test-toggle");

        Array.prototype.forEach.call(inputs, function (input) {
            input.checked = false;
        });

        curStepIndex = 1;
        slider.slideTo(0, 0);
        slider.params.custom.requested = false;
        slider.params.custom.nextStepRequest = false;

        const activeSlide = slider.slides[slider.activeIndex];
        activeSlide.style.transition = 'none';

        container.classList.remove('_end-test');
        container.classList.remove('_start-test');

        const resultData = container.querySelector(".js-result");
        resultData.remove();

        for (const el of stepsNum) {
            el.innerHTML = '01';
        }

        const link = document.querySelector('.js-anchor-to-test-start');
        link.click();

        setTimeout(() => {
            activeSlide.style.transition = '';
            container.classList.add('_start-test');
        }, 1);

    }

    const onErrorLoad = function (data) {
        console.log("error ", data);
    };

    const sendRequest = function (onSuccess, onError) {
        const xhr = new XMLHttpRequest();
        slider.params.custom.createRequest = createRequest;

        xhr.addEventListener("load", function () {
            if (xhr.status === 200 && onSuccess) {
                onSuccess(xhr.response);
            } else {
                onError(xhr.response);
            }
        });

        xhr.addEventListener("error", function () {
            onError("Произошла ошибка соединения");
        });
        xhr.addEventListener("timeout", function () {
            onError("Запрос не успел выполниться за " + xhr.timeout + "мс");
        });

        xhr.timeout = 10000;

        xhr.open("GET", urlGlobal);
        xhr.send();
    }

    const preResultActions = function (resultValue) {
        let url = "?";
        let value = resultValue;

        // Array.prototype.forEach.call(allInputsValues, function (inputValue, index, arr) {
        //     value += inputValue.value[0];
        // });

        url += 'result' + "=" + value;

        url.replace(/\s/g, '+');

        const action = formEl.getAttribute("action");

        const query = action + url;

        // history.pushState("", "", url);
        urlGlobal = query;
        console.log(urlGlobal);
        sendRequest(processResults, onErrorLoad, true);
    }

    const debouncer = itsoftApp.utils.debouncer(preResultActions, 100);

    const calculateResult = function (allInputsValues) {
        let result = 0;
        Array.prototype.forEach.call(allInputsValues, function (toggle) {
            result += parseInt(toggle.point, 10);
        })

        console.log(result);

        return result;
    }

    const createRequest = function () {
        let allInputsValues = [];
        const actualTestStepEls = container.querySelectorAll(".js-step-block");

        allInputsValues = Array.prototype.map.call(actualTestStepEls, function (stepBlock) {
            const allTestInputsEls = stepBlock.querySelectorAll(".js-test-toggle") || [];
            const allCheckedInputs = Array.prototype.filter.call(allTestInputsEls, item => item.checked) || [];

            return {
                name: allCheckedInputs.length > 0 ? stepBlock.getAttribute("name") || stepBlock.getAttribute("data-name") || allCheckedInputs[0].name : '',
                value: allCheckedInputs.length > 0 ? Array.prototype.map.call(allCheckedInputs, (checkedTestInput) => checkedTestInput.value) : '',
                point: allCheckedInputs.length > 0 ? Array.prototype.map.call(allCheckedInputs, (checkedTestInput) => checkedTestInput.getAttribute("data-point")) : '0',
            }
        });

        let resultValue = calculateResult(allInputsValues);

        debouncer(resultValue);
    }

    const isLastStep = function (target) {
        const slide = target.closest('.swiper-slide');
        const curIndex = [...slider.slides].indexOf(slide) + 1;

        return curIndex === slider.slides.length;
    }

    const onToggleChange = function (evt) {
        const { target } = evt;

        let totalStepIndex = slider.slides.length;

        if (slider.params.custom.nextStepRequest || isLastStep(target)) {
            beforeRequest();
            return;
        }
        if (target.hasAttribute('data-next-step-last')) {
            const activeSlide = slider.slides[slider.activeIndex];
            const index = [...slider.slides].indexOf(activeSlide) + 1;
            totalStepIndex = index + 1;
            slider.params.custom.nextStepRequest = true;
        }

        if (target.hasAttribute('data-next-step-extra-label')) {
            const nextSlide = slider.slides[slider.activeIndex + 1];
            nextSlide.classList.add('_show-extra-label');
        }

        curStepIndex += 1;

        for (const el of stepsNum) {
            setTimeout(() => {
                el.innerHTML = `0${curStepIndex} / 0${totalStepIndex}`;
            }, delayChangeStepNum);
        }

        slider.slideNext();
    }

    const beforeRequest = function () {
        if (!slider.params.custom.requested) {
            slider.params.custom.requested = true;
            createRequest();
        }
    }

    const onPrevBtnClick = function (evt) {
        const activeSlide = slider.slides[slider.activeIndex];
        const inputs = activeSlide.querySelectorAll('.js-test-toggle');
        const checkedInput = [...inputs].filter(el => el.checked)[0];
        let totalStepIndex = slider.slides.length;

        if (checkedInput) {
            checkedInput.checked = false;
        }

        slider.params.custom.nextStepRequest = false;

        curStepIndex -= 1;

        slider.slidePrev();

        for (const el of stepsNum) {
            setTimeout(() => {
                el.innerHTML = curStepIndex === 1 ? '01' : `0${curStepIndex} / 0${totalStepIndex}`;
            }, delayChangeStepNum);
        }
    }

    const init = function () {
        Array.prototype.forEach.call(toggleEls, function (input) {
            input.addEventListener("click", onToggleChange);
        });

        Array.prototype.forEach.call(prevBtnEls, function (el) {
            el.addEventListener("click", onPrevBtnClick);
        });
    }

    if (startBtn) {
        startBtn.addEventListener("click", function (evt) {
            evt.preventDefault();

            if (!slider) {
                slider = Swiper.initedSliders["test"];
            };

            container.classList.add('_start-test')
        });
    }

    init();
});